import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import TpEvaluatorEmailCampaignAdmin from './TpEvaluatorEmailCampaignAdmin';
import TpEvaluatorAdmin from './TpEvaluatorAdmin';
import TpEvaluatorTextMessageAdmin from './TpEvaluatorTextMessageAdmin';
import TpEvaluatorPersonaAdmin from './TpEvaluatorPersonaAdmin';
import TpEvaluatorSchedulingAdmin from './TpEvaluatorSchedulingAdmin';
import EvaluatorLeadAdmin from '../EvaluatorLead/EvaluatorLeadAdmin';

export default class TpEvaluatorParentAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  tab = this.urlParams.has('tab') ? parseInt(this.urlParams.get('tab')) : 0;

  componentDidMount() {}

  tabs = [
    { label: 'TP Evaluator', id: 'tpevaluator', icon: 'fa-solid fa-user', component: <TpEvaluatorAdmin /> },
    {
      label: 'Email Campaign Export',
      id: 'tpevaluatoremailcampaignexport',
      icon: 'fa-solid fa-envelope',
      component: <TpEvaluatorEmailCampaignAdmin />,
      roleKey: 'email_campaign_export_tab',
    },
    {
      label: 'Text Message Export',
      id: 'tpevaluatortextmessageexport',
      icon: 'fa-solid fa-messages',
      component: <TpEvaluatorTextMessageAdmin />,
      roleKey: 'text_message_export_tab',
    },
    {
      label: 'Persona Export',
      id: 'tpevaluatorpersonaexport',
      icon: 'fa-solid fa-person',
      component: <TpEvaluatorPersonaAdmin />,
      roleKey: 'persona_export_tab',
    },
    {
      label: 'Scheduling Report',
      id: 'pevaluatorschedulingexport',
      icon: 'fa-solid fa-calendar-days',
      component: <TpEvaluatorSchedulingAdmin />,
      roleKey: 'scheduling_export_tab',
    },
    {
      label: 'Evaluator Leads',
      id: 'evaluatorleads',
      icon: 'fa-solid fa-address-book',
      component: <EvaluatorLeadAdmin />,
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.window}
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage
              tabs={this.tabs}
              openOnTab={this.tab}
              removeSearchParametersOnTabChange={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
